import { Pipe, PipeTransform } from '@angular/core';
import { Invoice } from '~gc/domains/invoices';

@Pipe({ name: 'isInvoiceStatus' })
export class IsInvoiceStatusPipe implements PipeTransform {
  transform(invoice?: Invoice, ...statuses: string[]): boolean {
    return invoice ? statuses.some(status => invoice.status === status) : false;
  }
}
